import types from '../types';
import { push } from '../../router/history';

export function getAccesToken() {
  return async (dispatch) => {
    return dispatch({
      type: types.GET_ACCESS_TOKEN,
      payload: {
        request: {
          url: 'powerbi/get-token-access',
          method: 'GET',
        },
      },
    });
  };
}

export function registerBi(values, date, hour) {
  let value = {};
  value = { ...values, date, hour };
  return async (dispatch) => {
    return dispatch({
      type: types.REGISTER,
      payload: {
        request: {
          url: 'powerbi/register',
          method: 'POST',
          data: value,
        },
      },
    })
      .then(async ({ payload }) => {
        push('/powerbi');
      })
      .catch((error) => {
        console.log('error---', error);
      });
  };
}
